/**
  A Lorinthe project.

  @Author: Tom Voorneveld <tom>
  @Date:   2019-04-28T17:44:34+03:00
  @Email:  tom@lorinthe.com
  @Project: Lorinthe
  @Last modified by:   tom
  @Last modified time: 2019-06-09T14:55:28+02:00
  @Copyright: (c) copyright Lorinthe BV, all rights reserved

  Show log line in console, if we are in debug mode:

    import Log from '@/lib/log'
    Log.i('It is working')

*/

import Conf from '@/config/settings'

const r = Conf.RUN_ENV // 'test', 'dev' or 'prod'

const Log = {
  // on test and dev only, so not on production installations (Google Lighthouse does not like console logging)
  e: function (log1, log2 = '', log3 = '') { if ('dev,test'.includes(r)) console.error(log1, log2, log3) }, // error
  w: function (log1, log2 = '', log3 = '') { if ('dev,test'.includes(r)) console.warn(log1, log2, log3) }, // warn
  n: function (log1, log2 = '', log3 = '') { if ('dev,test'.includes(r)) console.info(log1, log2, log3) }, // note

  a: function (log1, log2 = '', log3 = '') { if ('dev,test'.includes(r)) console.warn(log1, log2, log3) }, // alert
  i: function (log1, log2 = '', log3 = '') { if ('dev,test'.includes(r)) console.info(log1, log2, log3) }, // info

  // on dev only
  v: function (log1, log2 = '', log3 = '') { if ('dev'.includes(r)) console.log(log1, log2, log3) } // verbose
}

export default Log
